module.exports = __webpack_public_path__ + "img/eye.6b6d049c.svg";